export default __webpack_public_path__ + "static/notion-c205298d1d5cde0f196c1c4ea6e4ba3d.png";